<!-- 
<ng-container *ngIf="product">
        <div class="" (click)="productDetailPage(product)" >
            <div class="bg-image hover-overlay ripple text-center product-card-image-container" data-mdb-ripple-color="light">
                <ng-container *ngIf="product && product.images && product.images.front" >
                    <img loading="lazy" onError="this.onerror=null;this.src='https://img.stokkup.com/app/no-image.png';" [src]="getVendorImageUrl2(product.images.front)" [alt]="'Product Image of ' + product.brand + ' ' + product.style + ' ' + product.title"  class="img-thumbnail mt-2 product-card-img" style="box-shadow: none;">

                </ng-container>
                <ng-container *ngIf="product && product.images[0]">
                    <img loading="lazy" onError="this.onerror=null;this.src='https://img.stokkup.com/app/no-image.png';" [src]="getVendorImageUrl(product)" [alt]="'Product Image of ' + product.brand + ' ' + product.style + ' ' + product.title" class="img-thumbnail mt-2 product-card-img" style="box-shadow: none;">

                </ng-container>

            </div>
            <div class="card-body p-0 ms-3 mt-3 me-1">
                <span class="card-title small product-card-header product-card-header-text">{{product.style}}</span>
                <div class="card-title h6 product-card-header product-card-header-text">
                    {{ product.brand }} <span class="small fw-lighter">{{ product.title | removeNullString | ellipsis:40 | titlecase}}</span>
                </div>
            </div>
        </div>
</ng-container> -->

<ng-container *ngIf="product">
    <div class="product-card" (click)="productDetailPage(product)">
        <div class="bg-image hover-overlay ripple text-center product-card-image-container" data-mdb-ripple-color="light">
            <ng-container *ngIf="product && product.images && product.images.front">
                <img loading="lazy" onError="this.onerror=null;this.src='https://img.stokkup.com/app/no-image.png';" [src]="getVendorImageUrl2(product.images.front)" [alt]="'Product Image of ' + product.brand + ' ' + product.style + ' ' + product.title" class="img-thumbnail product-card-img" style="border: none;">
            </ng-container>
            <ng-container *ngIf="product && product.images[0]">
                <img loading="lazy" onError="this.onerror=null;this.src='https://img.stokkup.com/app/no-image.png';" [src]="getVendorImageUrl(product)" [alt]="'Product Image of ' + product.brand + ' ' + product.style + ' ' + product.title" class="img-thumbnail product-card-img" style="border: none;">
            </ng-container>
        </div>
        <div class="product-card-body-container">
            <span class="card-title product-card-header product-card-header-text">{{product.style}}</span>
            <br>
            <span class="fw-bold">
                {{ product.brand == 'Private Label' ? 'Custom' : product.brand }}
            </span>
            <span class="text-wrap">
                {{ product.title }}
            </span>
        </div>
    </div>
</ng-container>
